export const HERO_DESCRIPTION_CLASS =
    "text-base sm:text-2xl font-medium leading-5 italic mt-4 tracking-tight font-Montserrat text-Text_White ";
